module.exports = __webpack_public_path__ + "static/media/MongoDB.308cc836.png";